export function obterListaTipoCombustivel() {
  return (
    [
      { label: '01 - Álcool', value: 'ALCOOL' },
      { label: '02 - Gasolina', value: 'GASOLINA' },
      { label: '03 - Diesel', value: 'DIESEL' },
      { label: '16 - Álcool/Gas', value: 'ALCOOLGAS' },
      { label: '17 - Gas/Álcool/GNV', value: 'GASALCOOLGNV' },
      { label: '18 - Gasolina/Elétrico', value: 'GASOLINAELETRICO' },
    ]
  );
}
